<div
  class="pt-3 d-flex flex-column gap-1"
  *ngIf="{ userType: userType$ | async, selected: selected$ | async } as data">
  <h3 class="d-flex gap-1 align-items-center">
    <strong>{{
      'flu.wholesaler-pharmacy.' + data?.userType | cxTranslate
    }}</strong>
  </h3>
  <div
    class="d-flex gap-1 align-items-center"
    [ngClass]="{
      'selected-section': editable,
    }"
    *ngIf="data?.selected">
    <p class="p-0 m-0">
      {{ !editable ? ('flu.wholesaler-pharmacy.selected' | cxTranslate) : '' }}
      {{ data.selected?.name }} ({{
        (data.selected?.billingAddress || data.selected?.contactAddress)?.town
      }})
    </p>
  </div>
  <span class="color-error" *ngIf="!data.selected">
    {{
      'flu.wholesaler-pharmacy.missing-default.' + data?.userType | cxTranslate
    }}
  </span>
  <button
    (click)="openPopup()"
    class="c-button c-button--secondary mt-3"
    *ngIf="editable">
    {{
      (data.selected
        ? 'flu.wholesaler-pharmacy.change'
        : 'flu.wholesaler-pharmacy.select'
      ) | cxTranslate
    }}
  </button>
</div>
